import AOS from 'aos'
import EmblaCarousel from 'embla-carousel'
import { addPrevNextBtnsClickHandlers } from './modules/emblaArrows'
import { addDotBtnsAndClickHandlers } from './modules/EmblaDots'
import { setupProgressBar } from './modules/emblaProgress'
import { updateSelectedSnapDisplay } from './modules/emblaSelectedSnapDisplay'
import Fade from 'embla-carousel-fade'
import SimpleParallax from "simple-parallax-js/vanilla";

AOS.init({
	duration: 900,
	once: true
});

// Set Viewport Width (vw) Variable
new ResizeObserver(function(){
  let vw = document.documentElement.clientWidth / 100;
  document.documentElement.style.setProperty('--vw', vw + 'px');
  if(document.getElementById('alert-bar')) {
	 document.documentElement.style.setProperty('--alert-bar-height', document.getElementById('alert-bar').clientHeight + 'px');
  }
}).observe(document.documentElement);

jQuery(function($){
	$('.close-subscribe-bar').on('click', function(e){
		e.preventDefault();
		$('.header-subscribe-bar').slideUp(200);
		document.cookie = "hide_subscribe_bar=true";
	});


	// Header search: focus on show
	$('#header-search').on('shown.bs.collapse', function(){
		$('#header-search .keyword').focus();
	});

	// Close header search
	$(window).on('click', function() {
		$('#header-search').collapse('hide');
	});
	$('#header-search').on('click', function(event){
		event.stopPropagation();
	});

	$('.block-video-hero .video-pause-btn').on('click', function(e) {
		e.preventDefault();
		let video = $(this).closest('.block-video-hero').find('video')[0];
		if($(this).hasClass('paused')) {
			video.play();
		} else {
			video.pause();
		}
		$(this).toggleClass('paused');
	});

	$('.block-video-hero .scroll-to-next').on('click', function(e) {
		e.preventDefault();
		let parentEl = $(this).closest('.block-video-hero');
		parentEl.next()[0].scrollIntoView();
	});

	// Mobile Menu
	$('.mobile-menu-toggle').on('click', function(e){
		e.preventDefault();
		$(this).toggleClass('expanded');
		$('body').toggleClass('mobile-nav-expanded');
		$('.header-content').fadeToggle(100);
	});

	$('.main-nav li.menu-item-has-children').each(function(){
		let href = $(this).find('> a').attr('href');
		let txt = $(this).find('> a').text();
		$(this).append(`<a href="${href}" class="mobile-arrow-link" aria-label="${txt}"></a>`);
	});

	$('.main-nav li.menu-item-has-children > a.nav-link').on('click', function(e){
		if ($(window).width() < 1200) {
			e.preventDefault();
			$(this).closest('li').toggleClass('mobile-active');
			$(this).siblings('.sub-menu-wrap').slideToggle(300);
		}
	});

});


const parImg = document.getElementsByClassName('parallax-bg');
new SimpleParallax(parImg, {
	customWrapper: '.parallax-container',
	overflow: true,
});

// Slider: Cards
const cardsSlider = document.querySelectorAll(".cards-slider");
cardsSlider.forEach((emblaNode) => {
	const viewportNode = emblaNode.querySelector('.embla__viewport');
	const prevBtnNode = emblaNode.querySelector('.embla__button--prev');
	const nextBtnNode = emblaNode.querySelector('.embla__button--next');
	const dotsNode = emblaNode.querySelector('.embla__dots');

	const OPTIONS = {
		loop: true,

	};

	const emblaApi = EmblaCarousel(viewportNode, OPTIONS);

	const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
	  emblaApi,
	  prevBtnNode,
	  nextBtnNode
	);

	const removeDotBtnsAndClickHandlers = addDotBtnsAndClickHandlers(
		emblaApi,
		dotsNode
	);

	emblaApi.on('destroy', removePrevNextBtnsClickHandlers);
	emblaApi.on('destroy', removeDotBtnsAndClickHandlers);

});

// Slider: Text Card & Posts Slider
const textCarousels = document.querySelectorAll(".text-cards-slider, .post-cards-slider");
textCarousels.forEach((emblaNode) => {
	const viewportNode = emblaNode.querySelector('.embla__viewport');
	const prevBtn = emblaNode.querySelector('.embla__button--prev');
	const nextBtn = emblaNode.querySelector('.embla__button--next');
	const progressNode = emblaNode.querySelector('.embla__progress__bar');

	const emblaApi = EmblaCarousel(viewportNode, {
		align: 'start',

	});
	const { applyProgress, removeProgress } = setupProgressBar(
	  emblaApi,
	  progressNode
	);

	const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
	  emblaApi,
	  prevBtn,
	  nextBtn
	);

	emblaApi
	  .on('init', applyProgress)
	  .on('reInit', applyProgress)
	  .on('scroll', applyProgress)
	  .on('slideFocus', applyProgress)
	  .on('destroy', removeProgress)
	  .on('destroy', removePrevNextBtnsClickHandlers);
});

// Slider: Featured Content
const featuredContentSlider = document.querySelectorAll(".featured-content-slider");
featuredContentSlider.forEach((emblaNode) => {
	const viewportNode = emblaNode.querySelector('.embla__viewport');
	const prevBtn = emblaNode.querySelector('.embla__button--prev');
	const nextBtn = emblaNode.querySelector('.embla__button--next');
	const progressNode = emblaNode.querySelector('.embla__progress__bar');

	const emblaApi = EmblaCarousel(viewportNode, {
		align: 'start',

	});
	const { applyProgress, removeProgress } = setupProgressBar(
	  emblaApi,
	  progressNode
	);

	const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
	  emblaApi,
	  prevBtn,
	  nextBtn
	);

	emblaApi
	  .on('init', applyProgress)
	  .on('reInit', applyProgress)
	  .on('scroll', applyProgress)
	  .on('slideFocus', applyProgress)
	  .on('destroy', removeProgress)
	  .on('destroy', removePrevNextBtnsClickHandlers);
});


// Slider: Testimonials & Featured Posts
const testimonialCarousels = document.querySelectorAll(".testimonial-carousel, .featured-posts-slider");
testimonialCarousels.forEach((emblaNode) => {
	const viewportNode = emblaNode.querySelector('.embla__viewport');
	const prevBtnNode = emblaNode.querySelector('.embla__button--prev');
	const nextBtnNode = emblaNode.querySelector('.embla__button--next');
	const dotsNode = emblaNode.querySelector('.embla__dots');

	const OPTIONS = {
		loop: true,
		duration: 40,

	};

	const emblaApi = EmblaCarousel(viewportNode, OPTIONS, [Fade()]);

	const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
	  emblaApi,
	  prevBtnNode,
	  nextBtnNode
	);

	const removeDotBtnsAndClickHandlers = addDotBtnsAndClickHandlers(
		emblaApi,
		dotsNode
	);

	emblaApi.on('destroy', removePrevNextBtnsClickHandlers);
	emblaApi.on('destroy', removeDotBtnsAndClickHandlers);
});



// Slider: Search Results
const searchCarousels = document.querySelectorAll(".search-results-carousel");
searchCarousels.forEach((emblaNode) => {
	const viewportNode = emblaNode.querySelector('.embla__viewport');
	const prevBtnNode = emblaNode.querySelector('.embla__button--prev');
	const nextBtnNode = emblaNode.querySelector('.embla__button--next');
	const snapDisplayNode = emblaNode.querySelector('.embla__selected-snap-display');

	const OPTIONS = {
		align: 'start',
	};

	const emblaApi = EmblaCarousel(viewportNode, OPTIONS);

	const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
	  emblaApi,
	  prevBtnNode,
	  nextBtnNode
	);

	updateSelectedSnapDisplay(emblaApi, snapDisplayNode);

	emblaApi.on('destroy', removePrevNextBtnsClickHandlers);
});
